export default {
  'pages.agent.profile.title': 'Agent Profile',
  'pages.agent.profile.subtitle': 'Manage agent information, cooperation status and related data',
  'pages.agent.profile.edit': 'Edit',

  // List
  'pages.agent.profile.column.operation': 'Operation',
  'pages.agent.profile.column.agentCode': 'Agent Code',
  'pages.agent.profile.column.agentName': 'Agent Name',
  'pages.agent.profile.column.agentType': 'Agent Type',
  'pages.agent.profile.column.contactName': 'Contact Person',
  'pages.agent.profile.column.contactPhone': 'Phone',
  'pages.agent.profile.column.coverageArea': 'Coverage Area',
  'pages.agent.profile.column.tenantCount': 'Tenants',
  'pages.agent.profile.column.deviceCount': 'Devices',
  'pages.agent.profile.column.commissionRate': 'Commission Rate',
  'pages.agent.profile.column.cooperationStatus': 'Status',
  'pages.agent.profile.column.createTime': 'Created Time',

  // Delete/Export
  'pages.agent.profile.deleteSuccess': 'Deleted successfully',
  'pages.agent.profile.deleteFailed': 'Delete failed, please try again later',
  'pages.agent.profile.deleteConfirm': 'Are you sure to delete this agent?',
  'pages.agent.profile.exportSuccess': 'Exported successfully',
  'pages.agent.profile.exportFailed': 'Export failed',
  'pages.agent.profile.export': 'Export',
  'pages.agent.profile.exportFileName': 'Agent List',
  'pages.agent.profile.confirm': 'Confirm',

  // Modal
  'pages.agent.profile.modal.addTitle': 'Add Agent',
  'pages.agent.profile.modal.editTitle': 'Edit Agent',
  'pages.agent.profile.modal.subtitle': 'Please fill in the agent information, contact details, and business configuration. * indicates required fields',
  'pages.agent.profile.modal.cancel': 'Cancel',
  'pages.agent.profile.modal.saveSuccess': 'Saved successfully',
  'pages.agent.profile.modal.addSuccess': 'Created successfully',

  // Add/Edit page
  'pages.agent.profile.page.addTitle': 'Add Agent',
  'pages.agent.profile.page.editTitle': 'Edit Agent',
  'pages.agent.profile.cancel': 'Cancel',
  'pages.agent.profile.save': 'Save',
  'pages.agent.profile.getDetailFailed': 'Failed to get agent detail',

  // Form labels
  'pages.agent.profile.modal.name': 'Agent Name',
  'pages.agent.profile.modal.namePlaceholder': 'Please enter agent name',
  'pages.agent.profile.modal.code': 'Agent Code',
  'pages.agent.profile.modal.codePlaceholder': 'e.g., AG-MM-001',
  'pages.agent.profile.modal.type': 'Agent Type',
  'pages.agent.profile.modal.typePlaceholder': 'Please select agent type',
  'pages.agent.profile.modal.area': 'Coverage Area',
  'pages.agent.profile.modal.areaPlaceholder': 'Please enter coverage area',
  'pages.agent.profile.modal.contactInfo': 'Contact Information',
  'pages.agent.profile.modal.contactPerson': 'Contact Person',
  'pages.agent.profile.modal.phone': 'Phone',
  'pages.agent.profile.modal.email': 'Email',
  'pages.agent.profile.modal.tin': 'TIN Number',
  'pages.agent.profile.modal.address': 'Company Address',
  'pages.agent.profile.modal.businessConfig': 'Business Configuration',
  'pages.agent.profile.modal.commissionRate': 'Commission Rate (%)',
  'pages.agent.profile.modal.commissionMode': 'Commission Mode',
  'pages.agent.profile.modal.commissionModePlaceholder': 'Please select commission mode',
  'pages.agent.profile.modal.settlementCycle': 'Settlement Cycle',
  'pages.agent.profile.modal.settlementCyclePlaceholder': 'Please select settlement cycle',
  'pages.agent.profile.modal.cooperationStatus': 'Cooperation Status',
  'pages.agent.profile.modal.cooperationStatusPlaceholder': 'Please select cooperation status',
  'pages.agent.profile.modal.startDate': 'Cooperation Start Date',
  'pages.agent.profile.modal.endDate': 'Contract Expiry Date',
  'pages.agent.profile.modal.otherInfo': 'Other Information',
  'pages.agent.profile.modal.remark': 'Remark',

  // Form sections
  'pages.agent.profile.section.basicInfo': 'Basic Information',
  'pages.agent.profile.section.basicInfoAlt': 'Basic Information',

  // Form validation
  'pages.agent.profile.form.startDateFormat': 'Start date cannot be later than end date',
  'pages.agent.profile.form.endDateFormat': 'End date cannot be earlier than start date',

  // Form common
  'pages.agent.profile.form.selectPlaceholder': 'Select coverage area',
  'pages.agent.profile.form.codeRequired': 'Please enter agent code',
  'pages.agent.profile.form.nameRequired': 'Please enter agent name',
  'pages.agent.profile.form.contactRequired': 'Please enter contact person name',
  'pages.agent.profile.form.phoneRequired': 'Please enter phone number',
  'pages.agent.profile.form.phonePlaceholder': 'Please enter phone number',
  'pages.agent.profile.form.emailRequired': 'Please enter email address',
  'pages.agent.profile.form.emailInvalid': 'Please enter a valid email address',
  'pages.agent.profile.form.emailPlaceholder': 'Please enter email address',
  'pages.agent.profile.form.addressRequired': 'Please enter detailed address',
  'pages.agent.profile.form.startDateRequired': 'Please select cooperation start date',
  'pages.agent.profile.form.remarkPlaceholder': 'Enter remarks',
  'pages.agent.profile.form.addressPlaceholder': 'Please enter detailed address',
  'pages.agent.profile.form.tinPlaceholder': 'Please enter TIN number',
  'pages.agent.profile.form.commissionPlaceholder': 'Please enter commission rate',
  'pages.agent.profile.form.contactPlaceholder': 'Please enter contact person name',

  // Commission mode options
  'pages.agent.profile.commissionMode.byDevice': 'By Device Count',
  'pages.agent.profile.commissionMode.byTenant': 'By Tenant Count',
  'pages.agent.profile.commissionMode.byTransaction': 'By Transaction Amount',

  // Settlement cycle options
  'pages.agent.profile.settlementCycle.monthly': 'Monthly Settlement',
  'pages.agent.profile.settlementCycle.quarterly': 'Quarterly Settlement',
  'pages.agent.profile.settlementCycle.yearly': 'Yearly Settlement',
};
